/*
 * Purpose: Safe env reads for Vite browser + Node test runners
 * Last modified: 2026-06-25 | Agent
 * Completeness: 95
 */

export function readEnv(key: string): string | undefined {
  if (typeof import.meta !== 'undefined') {
    const v = import.meta.env?.[key];
    if (typeof v === 'string' && v.length > 0) return v;
  }
  if (typeof process !== 'undefined' && process.env) {
    const v = process.env[key];
    if (typeof v === 'string' && v.length > 0) return v;
  }
  return undefined;
}

export function readEnvOr(key: string, fallback: string): string {
  return readEnv(key) ?? fallback;
}
